/* ============
 * Edi Order Module State
 * ============
 */

export default {
  all: [],
  items: [],
  pagination: {
    currentPage: 1,
    lastPage: 0,
    limit: 5,
    totalCount: 0,
  },
  currentEdiOrder: {},
};




// WEBPACK FOOTER //
// ./src/app/store/modules/ediOrder/state.js